import { Avatar } from "@mantine/core";

/**
 * A user's avatar rendered as deterministic initials + a name-derived color (Mantine
 * `color="initials"`). Used everywhere a user appears — the header menu, the activity feed — so the
 * SAME person always shows the SAME initials and color and is recognizable at a glance. Always pass
 * the full display name (e.g. "John Test" → "JT"); the name is trimmed so trailing-space variants
 * hash to the same color.
 */
export default function UserInitialsAvatar({ name, ...props }) {
  return <Avatar color="initials" name={(name || "").trim()} radius="xl" {...props} />;
}
